const moduleoptioncoursetypes = {
	title: "Modulalternativ - Kurstype",
	new_moduleoptioncoursetype: "Nytt modulalternativ - Kurstype",
	edit_moduleoptioncoursetype: "Rediger modulalternativ - Kurstype: {name}",
	id: "ID",
	moduleoption_id: "Modulalternativ",
	coursetype_id: "Kurstype",
	coursetypegroup_id: "Kurstypegruppe",
	name: "Navn",
	price: "Pris",
	comment: "Kommentar",
};
export default moduleoptioncoursetypes;